import { api } from "../AxiosInstance";

export function getPlansApi(params) {
  return api().get("/api/Planning/GetAllCurrentTenantPlan", { params });
}

export function createPlanApi(plan) {
  return api().post("/api/Planning/Create", plan);
}

export function postPlanConfigApi(config) {
  return api().put("/api/Planning/SetConfig", config);
}

export function getToolNameListApi(config) {
  return api().get("/api/Resources/GetToolNamesForOrganization", config);
}

export function updatePlanApi(config) {
  return api().put("/api/Planning/UpdatePlan", config);
}

export function restorePlanApi(data) {
  return api().put("/api/Planning/RestoreDeletedPlan", data);
}

export function restoreDriverApi(data) {
  return api().put("/api/DriverInfo/RestoreDeletedDriver", data);
}

export function errorPlanMessageApi(params) {
  return api().get("/api/Planning/GetPlanStatus", { params });
}

export function executePlanApi(plan) {
  return api().post("/api/PlanService/ExecuteTool", plan);
}

export function missionInfoByIdApi(params) {
  return api().get("/api/Dispatch/SearchMissionRelatedInfo", { params });
}

export function deletePlanApi(params) {
  return api().delete("/api/Planning/Delete", { params });
}

export function DownloadResultOptimzeFileApi(params) {
  return api().get("/api/PlanService/DownloadResultOptimzeFile", { params });
}

export function DownloadExcelFileApi(params) {
  return api().get("/api/PlanService/DownloadPlanFile", { params });
}

export function downloadPlanFormApi(params) {
  return api().get("/api/DigikalaBusiness/ExportB2BMissionForm", { params });
}
// export function downloadPlanFormApi(params) {
//   return api().get("/api/DriverCluster/ExportMissionFormInputData", { params });
// };

export function getFromExternalSourceApi(params) {
  return api().get("/api/Planning/GetFromExternalSource", { params });
}

export function getPlanLogsApi(params) {
  return api().get("/api/PlanService/GetPlanLogs", { params });
}
